<template>
  <b-card
    no-body
    class=" border border-2 h-100"
  >
    <div class="flex justify-between items-start px-1 pt-1">
      <div>
        <div class="font-bold text-[16px] text-black">
          Conversion Rate
        </div>
        <div class="text-[#A0A0A0] text-[12px]">
          Conversion rate leads and closing
        </div>
      </div>
      <MonthFilter
        :month.sync="month"
      />
    </div>

    <div class="flex gap-2 mb-4 px-1 mt-1">
      <div class="border rounded p-1 flex-1">
        <div class="text-[#A0A0A0] text-[12px] flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-full bg-[#3B82F6]" /> <span>by Percentage</span>
        </div>
        <div class="font-bold text-[18px]">
          {{ percentage }}%
        </div>
      </div>
      <div class="border rounded p-1 flex-1">
        <div class="text-[#A0A0A0] text-[12px] flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-full bg-[#F97316]" /> <span>Leads</span>
        </div>
        <div class="font-semibold text-lg">
          {{ totalLeads }}
        </div>
      </div>
      <div class="border rounded p-1 flex-1">
        <div class="text-[#A0A0A0] text-[12px] flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-full bg-[#22C55E]" /> <span>Closing</span>
        </div>
        <div class="font-bold text-[18px]">
          {{ totalClosing }}
        </div>
      </div>
    </div>

    <div class="px-1 mt-4">
      <vue-apex-charts
        type="area"
        height="250"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import { START_DATE_OF_MONTH, END_DATE_OF_MONTH, MONTH_NAME } from '@/libs/filterDate'
import MonthFilter from './MonthFilter.vue'
import { apiDataConversionRate } from '../services/api.komchat.service'

export default {
  name: 'ConversionRateChart',
  components: {
    'vue-apex-charts': VueApexCharts,
    MonthFilter,
  },
  data() {
    return {
      moment,
      month: moment(),
      totalLeads: 0,
      totalClosing: 0,
      percentage: '0',
      series: [
        { name: 'Leads', data: [] },
        { name: 'Closing', data: [] },
      ],
      chartOptions: {
        chart: {
          type: 'area',
          toolbar: { show: false },
          zoom: { enabled: false },
          background: 'transparent',
        },
        colors: ['#F97316', '#22C55E'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.6,
            opacityTo: 0.1,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: ['1', '3', '5', '7', '9', '11', '13', '15', '17', '19', '31'],
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            show: true,
            style: {
              colors: '#A0A0A0',
              fontSize: '12px',
            },
          },
        },
        yaxis: {
          show: true,
          tickAmount: 6,
          labels: {
            style: { colors: '#A0A0A0' },
          },
        },
        legend: { show: false },
        grid: {
          show: true,
          borderColor: '#f1f1f1',
          strokeDashArray: 0,
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: true } },
        },
        tooltip: {
          theme: 'light',
        },
      },
    }
  },
  watch: {
    month() {
      this.fetchData()
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const startDate = START_DATE_OF_MONTH(this.month)
      const endDate = END_DATE_OF_MONTH(this.month)

      try {
        const res = await apiDataConversionRate({ startDate, endDate })
        if (res && res.data && res.data.data) {
          const { leads, closing } = res.data.data
          const leadsArray = leads || []
          const closingArray = closing || []

          const sumLeads = leadsArray.reduce((a, b) => a + b, 0)
          const sumClosing = closingArray.reduce((a, b) => a + b, 0)

          this.totalLeads = sumLeads
          this.totalClosing = sumClosing
          this.percentage = sumLeads > 0 ? parseFloat(((sumClosing / sumLeads) * 100).toFixed(2)) : 0

          this.series = [
            { name: 'Leads', data: leadsArray },
            { name: 'Closing', data: closingArray },
          ]

          const categories = Array.from(
            { length: leadsArray.length },
            (_, i) => `${i + 1}`,
          )

          this.chartOptions = {
            ...this.chartOptions,
            xaxis: {
              ...this.chartOptions.xaxis,
              categories,
            },
          }
        } else {
          this.totalLeads = 0
          this.totalClosing = 0
          this.percentage = 0
          this.series = [
            { name: 'Leads', data: [] },
            { name: 'Closing', data: [] },
          ]
        }
      } catch (err) {
        console.error('Failed to fetch conversion rate', err)
      }
    },
  },
}
</script>
